import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionToggleService {
  private isV2Subject: BehaviorSubject<boolean>;

  public isV2$: Observable<boolean>;

  constructor() {
    // Initialize based on environment version
    const isV2 = environment.version === 'V2';
    this.isV2Subject = new BehaviorSubject<boolean>(isV2);
    this.isV2$ = this.isV2Subject.asObservable();
  }

  public isV2(): boolean {
    return this.isV2Subject.value;
  }

  public setV2(isV2: boolean): void {
    this.isV2Subject.next(isV2);
  }
}
